import {invoiceRepository} from '@/repositories/Index';


class invoiceService {
    // 获取可开票发票列表
    async getInvoiceAblesWithCPCFn(params: any) {
      const res = await invoiceRepository.getInvoiceAblesWithCPC(params);
      return res;
    }
    
    //获取发票历史信息列表 带CPC
    async getInvoiceHistoryWithCPCFn(params: any) {
        const res = await invoiceRepository.getInvoiceHistoryWithCPC(params);
        return res;
    }

    //获取发票详情 带CPC
    async getInvoiceDetailWithCPCFn(params: any) {
        const res = await invoiceRepository.getInvoiceDetailWithCPC(params);
        return res;
    }

     //增加缓冲字符串
     async addCacheInvoiceJsonFn(params: any) {
      const res = await invoiceRepository.addCacheInvoiceJson(params);
      return res;
    } 
    //获取缓冲字符串
    async getCacheInvoiceJsonFn(params: any) {
      const res = await invoiceRepository.getCacheInvoiceJson(params);
      return res;
    }

     //钱包概览
     async getWalletInfo(params: any) {
      const res = await invoiceRepository.getWalletInfo(params);
      return res;
    } 
     
     //账户余额抹零
     async accountTruncation(params: any) {
      const res = await invoiceRepository.accountTruncation(params);
      return res;
    } 
     
    //资质校验
    async checkCertifyFn(params: any) {
      const res = await invoiceRepository.checkCertify(params);
      return res;
    }

    //发票邮寄状态及单号
    async invoicePostMessageFn(params: any) {
      const res = await invoiceRepository.invoicePostMessage(params);
      return res;
    }

    //提交发票申请
    async applyInvoiceFn(params: any) {
      const res = await invoiceRepository.applyInvoice(params);
      return res;
    }
    
  
  }
  
  export default invoiceService;
  